import { jsx as _jsx } from "react/jsx-runtime";
import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, LinearScale, LineElement, PointElement, Title, Tooltip } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { useContext, useEffect, useState } from 'react';
import { Bar, Doughnut, Line } from 'react-chartjs-2';
import { BLACK_800 } from '../../constants';
import { StateConfigContext } from '../../providers';
import { getChartProps, getChartStyles } from './ChartStyles';
import { ChartRenderer } from './components/chart-renderer/ChartRenderer';
import ChartDataLabels from 'chartjs-plugin-datalabels';
var commonConfig = {
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip
};
var _lineConfig = Object.assign(Object.assign({}, commonConfig), {
  LineElement
});
var _barConfig = Object.assign(Object.assign({}, commonConfig), {
  BarElement
});
var _doughnutConfig = Object.assign(Object.assign({}, commonConfig), {
  arc: ArcElement
});
export var Chart = _props => {
  var stateContext = useContext(StateConfigContext);
  var props = getChartProps(_props, stateContext);
  var chartStyles = getChartStyles(props);
  var _useState = useState(false),
    isMounted = _useState[0],
    setIsMounted = _useState[1];
  var _props$legendAlignmen = props.legendAlignment,
    legendAlignment = _props$legendAlignmen === void 0 ? 'center' : _props$legendAlignmen,
    title = props.title,
    _props$type = props.type,
    type = _props$type === void 0 ? 'line' : _props$type,
    _props$legendPosition = props.legendPosition,
    legendPosition = _props$legendPosition === void 0 ? type == 'doughnut' ? 'right' : 'top' : _props$legendPosition,
    _props$hideLegend = props.hideLegend,
    hideLegend = _props$hideLegend === void 0 ? false : _props$hideLegend,
    data = props.data,
    optionsProp = props.options,
    xAxisLabel = props.xAxisLabel,
    yAxisLabel = props.yAxisLabel,
    _props$titleAlignment = props.titleAlignment,
    titleAlignment = _props$titleAlignment === void 0 ? 'start' : _props$titleAlignment,
    _props$hideScale = props.hideScale,
    hideScale = _props$hideScale === void 0 ? false : _props$hideScale,
    _props$showAnnotation = props.showAnnotation,
    showAnnotation = _props$showAnnotation === void 0 ? false : _props$showAnnotation,
    renderCustomTooltipTitle = props.renderCustomTooltipTitle,
    renderCustomTooltipLabel = props.renderCustomTooltipLabel,
    renderCustomTooltipFooter = props.renderCustomTooltipFooter,
    showCustomTootip = props.showCustomTootip,
    annotationsData = props.annotationsData;
  var _useState2 = useState(optionsProp),
    options = _useState2[0],
    setOptions = _useState2[1];
  useEffect(() => {
    if (showAnnotation) ChartJS.register(annotationPlugin);
    ChartJS.register(ChartDataLabels);
    ChartJS === null || ChartJS === void 0 ? void 0 : ChartJS.register(type === 'line' ? _lineConfig : type === 'bar' ? _barConfig : _doughnutConfig);
    setIsMounted(true);
  }, []);
  useEffect(() => {
    setOptions(Object.assign({
      elements: {
        arc: {
          circular: true,
          borderWidth: 0
        }
      },
      plugins: Object.assign(Object.assign(Object.assign({}, showCustomTootip && {
        tooltip: {
          callbacks: {
            title: renderCustomTooltipTitle,
            label: renderCustomTooltipLabel,
            footer: renderCustomTooltipFooter
          }
        }
      }), showAnnotation && Object.assign({}, annotationsData)), {
        legend: {
          display: false
        },
        title: {
          display: !!title,
          text: title,
          align: titleAlignment
        },
        datalabels: {
          color: 'transparent'
        }
      }),
      scales: !hideScale && {
        x: {
          title: {
            text: xAxisLabel,
            display: !!xAxisLabel || (xAxisLabel === null || xAxisLabel === void 0 ? void 0 : xAxisLabel.length) > 0,
            color: BLACK_800
          }
        },
        y: {
          title: {
            text: yAxisLabel,
            display: !!yAxisLabel || (yAxisLabel === null || yAxisLabel === void 0 ? void 0 : yAxisLabel.length) > 0,
            color: BLACK_800
          }
        }
      }
    }, optionsProp));
  }, [hideLegend, legendPosition, legendAlignment, title, titleAlignment, xAxisLabel, yAxisLabel, optionsProp]);
  if (!isMounted) {
    return null;
  }
  var ChartComponent;
  switch (type) {
    case 'line':
      ChartComponent = Line;
      break;
    case 'bar':
      ChartComponent = Bar;
      break;
    case 'doughnut':
      ChartComponent = Doughnut;
      break;
    default:
      ChartComponent = Line;
  }
  return _jsx(ChartRenderer, Object.assign({}, props, {
    chartComponent: _jsx(ChartComponent, {
      data: data,
      options: options,
      style: chartStyles.chartStyle
    })
  }));
};